import { render, staticRenderFns } from "./PricingContextDetails.vue?vue&type=template&id=527504b7&"
import script from "./PricingContextDetails.vue?vue&type=script&lang=ts&"
export * from "./PricingContextDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports